var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { PdfExportService } from '../../../../services/export-pdf/pdf-export.service';
import { UserService } from '../../../../services/user.service';
import { AchooPieChartComponent } from '../../../../core/achoo-pie-chart/achoo-pie-chart.component';
import { TranslateService } from '@ngx-translate/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { chartConfig } from '../../../../app.constants';
var SponsoredVsOrganicComponent = /** @class */ (function (_super) {
    __extends(SponsoredVsOrganicComponent, _super);
    function SponsoredVsOrganicComponent(pdfService, userService, translate, deviceService) {
        var _this = _super.call(this, pdfService, userService, translate, deviceService) || this;
        _this.pdfService = pdfService;
        _this.userService = userService;
        _this.translate = translate;
        _this.deviceService = deviceService;
        _this._placeholderData = [
            {
                name: 'all',
                x: 1,
                y: 100,
                color: 'rgba(149,160,177, 0.1)'
            }
        ];
        _this.overridenPiePlotOptions = {
            borderWidth: 0
        };
        return _this;
    }
    SponsoredVsOrganicComponent.prototype.ngOnInit = function () {
        this.organicColor = this.userService.chartColors[0];
        this.sponsoredColor = this.userService.chartColors[1];
        var _a = this.extractSponsoredOrganicPercentage(this.sponsoredOrganicPercentage), showPlaceholder = _a.showPlaceholder, organicPercentage = _a.organicPercentage, sponsoredPercentage = _a.sponsoredPercentage, chartData = _a.chartData;
        this.hasNoData = showPlaceholder;
        this.organicPercentage = organicPercentage;
        this.sponsoredPercentage = sponsoredPercentage;
        this.options = {
            chart: {
                height: this.height,
                type: chartConfig.type.pie,
                margin: [0, 0, 0, 0],
                spacingTop: 0,
                spacingBottom: 0,
                spacingLeft: 0,
                spacingRight: 0,
                style: {
                    fontFamily: chartConfig.font.light
                },
            },
            colors: this.userService.chartColors,
            tooltip: {
                enabled: false
            },
            plotOptions: {
                pie: {
                    size: '100%',
                    height: '100%',
                    dataLabels: {
                        enabled: false
                    },
                    showInLegend: false,
                    borderWidth: 0
                },
                series: {
                    animation: !this.pdfService.exportingPdf
                }
            },
            legend: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            title: {
                text: ''
            },
            series: [{
                    data: chartData,
                    size: chartConfig.pieChart.size,
                    innerSize: '72%'
                }]
        };
    };
    SponsoredVsOrganicComponent.prototype.ngOnChanges = function (changes) {
        if (changes.sponsoredOrganicPercentage) {
            var _a = this.extractSponsoredOrganicPercentage(changes.sponsoredOrganicPercentage.currentValue), showPlaceholder = _a.showPlaceholder, organicPercentage = _a.organicPercentage, sponsoredPercentage = _a.sponsoredPercentage, chartData = _a.chartData;
            this.hasNoData = showPlaceholder;
            this.organicPercentage = organicPercentage;
            this.sponsoredPercentage = sponsoredPercentage;
            if (this.chart) {
                this.chart.series[0].setData(chartData);
            }
        }
    };
    SponsoredVsOrganicComponent.prototype.saveInstance = function (chartInstance) {
        this.chart = chartInstance;
    };
    SponsoredVsOrganicComponent.prototype.clickLegend = function (legend) {
        if (!this.chart || this.hasNoData) {
            return;
        }
        this.chart.series[0].points.forEach(function (p) {
            if (p.name.toLowerCase() === legend) {
                var isVisible = p.visible;
                var updatedPoint = Object.assign({}, p, {
                    visible: !isVisible
                });
                p.update(updatedPoint);
            }
        });
    };
    SponsoredVsOrganicComponent.prototype.hoverLegend = function (legend) {
        if (!this.chart || this.hasNoData) {
            return;
        }
        this.chart.series[0].points.forEach(function (p) {
            if (p.name.toLowerCase() === legend) {
                p.onMouseOver();
            }
        });
    };
    SponsoredVsOrganicComponent.prototype.isVisibleLegend = function (legend) {
        if (!this.chart) {
            return false;
        }
        var activePoint = this.chart.series[0].points.find(function (p) { return p.name.toLowerCase() === legend; });
        return activePoint && activePoint.visible;
    };
    SponsoredVsOrganicComponent.prototype.extractSponsoredOrganicPercentage = function (value) {
        if (!Array.isArray(value) || value.length !== 2) {
            return {
                showPlaceholder: true,
                organicPercentage: null,
                sponsoredPercentage: null,
                chartData: this._placeholderData
            };
        }
        var organicPercentage = value.find(function (x) { return x.name === 'Organic'; }).percent * 100;
        var sponsoredPercentage = 100 - organicPercentage;
        return {
            showPlaceholder: false,
            organicPercentage: organicPercentage,
            sponsoredPercentage: sponsoredPercentage,
            chartData: [
                {
                    name: 'sponsored',
                    x: 0,
                    y: sponsoredPercentage,
                    color: this.userService.chartColors[1]
                },
                {
                    name: 'organic',
                    x: 1,
                    y: organicPercentage,
                    color: this.userService.chartColors[0]
                }
            ]
        };
    };
    return SponsoredVsOrganicComponent;
}(AchooPieChartComponent));
export { SponsoredVsOrganicComponent };



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-overview/sponsored-vs-organic/sponsored-vs-organic.component.ts.pre-build-optimizer.js